import { useEffect } from "react";
import { trackPageview } from "../../utils/analyticsUtils";
import { LuLoaderCircle } from "react-icons/lu";
import { LOCAL_STORAGE_KEYS } from "../../config/local_storage_keys";
import { PremiumFullscreenLayout } from "../common_components/PremiumFullscreenLayout";
import { colors, typography } from "../../design/tokens";

export default function SubscriptionsFailurePage() {
  useEffect(() => {
    trackPageview("Payment Failure");
  }, []);

  useEffect(() => {
    const returnUrl = localStorage.getItem(
      LOCAL_STORAGE_KEYS.SUBSCRIPTIONS_MODAL_RETURN_URL
    );
    localStorage.removeItem(LOCAL_STORAGE_KEYS.SUBSCRIPTIONS_MODAL_RETURN_URL);

    window.location.replace(returnUrl || "/");
  }, []);

  return (
    <PremiumFullscreenLayout>
      <div className="flex flex-col items-center justify-center gap-4">
        <LuLoaderCircle size={56} className="animate-spin text-white" />
        <p
          className={`${typography.size.lg} text-center`}
          style={{ color: colors.hex.white }}
        >
          Returning back to the app...
        </p>
      </div>
    </PremiumFullscreenLayout>
  );
}
